var FIVE_MINUTES_IN_MS, checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, intervalID, setCLLTimer, success, successCallback,
  slice = [].slice;

cllCookie = require('./m_location_helper').cllCookie;

successCallback = errorCallback = intervalID = void 0;

FIVE_MINUTES_IN_MS = 1000 * 60 * 5;


/**
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   position        - Position information returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(position) {
  var lat, lng, ref;
  ref = position != null ? position.coords : void 0, lat = ref.latitude, lng = ref.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  if (intervalID) {
    clearInterval(intervalID);
  }
  intervalID = setInterval(detectCurrentLocation, FIVE_MINUTES_IN_MS);
  cllCookie.set(position);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/**
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/**
 * Function to set the timer for CLL
 */

setCLLTimer = function() {
  var TTL, currentTime;
  currentTime = Date.now();
  TTL = (typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('cll_TTL') : void 0) || Cookie.get('cll_TTL') || currentTime;
  if (currentTime >= TTL) {
    return detectCurrentLocation();
  } else {
    return setTimeout(detectCurrentLocation, TTL - currentTime);
  }
};


/**
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/**
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref = Groupon.LS.options) != null ? ref.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation,
  setCLLTimer: setCLLTimer
};

